import Resolution from 'engine/Resolution.js';

export function convertPatternToValue(patternToValue) {
    let converted = {};
    for (let i in patternToValue) {
        let value = patternToValue[i];
        converted[i] = convertValue(value);
    }

    return converted;
}

export function convertValue(value) {
    if (value === null) {
        return value;
    }
    if (typeof value === 'object') {
        if (value.resolution) {
            value = new Resolution(16, false)
                .fromJson(value);
        }
    }
    return value;
}
